import {
  FAMYLOCATE_ROOT_DOMAIN,
  SAFE_FAMILY_ROOT_DOMAIN,
} from 'root-constants/common'

export const getIsFamylocateDomain = (): boolean =>
  window.location.hostname.includes(FAMYLOCATE_ROOT_DOMAIN) ||
  window.location.hostname.includes(SAFE_FAMILY_ROOT_DOMAIN)
